import { graphql } from 'react-relay';

export const performanceOverviewFragment = graphql`
  fragment PerformanceOverview_component on PerformanceOverview
  @refetchable(queryName: "PerformanceOverviewRefetchQuery")
  @argumentDefinitions(
    loadData: { type: "Boolean", defaultValue: false }
    reportcurrency: { type: "String" }
  ) {
    id
    header
    disclaimer
    staticDisclaimer
    chart @include(if: $loadData) {
      id
      data(reportcurrency: $reportcurrency) {
        performance
        benchmark
        date
      }
      ...PerformanceOverviewChart_chart
    }
    info {
      ...PerformanceOverviewNumbers_data
      ...PerformanceOverviewInfo_data
    }
    menu(reportcurrency: $reportcurrency) {
      currencySelectionSaveButtonText
      currencySelectionInfo
      currencySelectionHeader
      ...PerformanceOverviewMenu_menu
      currencySelectBox {
        ...PerformanceOverviewCurrencySelection_currencySelection
      }
    }
  }
`;
